import React from "react"
import withStyles from "react-jss"
import colors from "../data/colors"

const styles = {
  link: {
    textDecoration: "none",
    color: colors.black,
  },
}

const Link = ({ classes, href, children, tabIndex }) => {
  return (
    <a
      className={classes.link}
      href={href}
      target="_blank"
      rel="noreferrer"
      tabIndex={tabIndex}>
      {children}
    </a>
  )
}

export default withStyles(styles)(Link)
